import React, { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { addBoxInPack } from '../../../../../api/pack/boxAPI'

const BoxSeriesForm = ({ packId, boxBd, setOpen }) => {

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const add = () => {
        setLoading(true)
        addBoxInPack({ packId }).then(data => {
            setOpen(false)
            setLoading(false)
        }).catch (e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='loginPage__form-inputs'>
        {
			error ?
				<div className='error'>
					{ error }
				</div>
			: ''
		}

        <MyButton
            size='md'
            onClick={add}
            disabled={loading ? true : false}
        >
            Створити порожню коробку
        </MyButton>
    </div>
  )
}

export default BoxSeriesForm